import { Injectable } from "@angular/core";
import { BaseViewerService } from "./base-viewer.service";

@Injectable({
  providedIn: "root",
})
export class CuratorViewerService extends BaseViewerService {
  setEmbeddingImplementation(dbType: string): void {
    this.viewerConfigurationService.setEmbeddingsImplementation(dbType);
  }
}
